const ErrorCode = {
  StationPriceToolNotFound: "S1000",
  StationNotFound: "S1002",
  StationNotFoundv1: "S1001",
  StationHasNoDepot: "S1007",
  CohortNotFound: "CH1001",
  CohortNameTaken: "CH1002",
  CohortGroupNotFound: "CH1003",
  CohortGroupNameTaken: "CH1004",
  CohortPatchNoFields: "CH1005",
  CampaignNotFound: "CP1001",
  ExecutiveSummaryFileMissing: "CP1031",
  ExecutiveSummaryFileNotHtml: "CP1032",
  ExecutiveSummaryFileTooLarge: "CP1033",
  ExecutiveSummaryUploadFailed: "CP1034",
  ExecutiveSummaryLoadFailed: "CP1035",
};

export default ErrorCode;
